// English copy. Spanish (es-MX) mirrors every key in es.ts.
import meta from "./meta.json";

const en = {
  // Page titles and descriptions are shared with scripts/prerender-routes.js.
  meta: meta.en,
  header: {
    home: "vaan.dev, home",
    desc: "Independent software, Mexico City",
    nav: "Main",
    work: "Work",
    about: "About",
    switchLabel: "Español",
    switchShort: "ES",
  },
  hero: {
    line: "Design your own action figure in the browser. Print it at home.",
    open: "Open DummyForge",
    facts: "Public beta · Free · EN / ES",
    roledesc: "360° view",
    figureLabel:
      "Debug-Man 1.0, a black action figure built from boxes with bronze-graphite joints, standing on a bronze plinth. Drag or use the arrow keys to turn it.",
    credit: "Debug-Man 1.0, made with DummyForge",
    hint: "Drag to turn",
  },
  work: {
    label: "Work",
    title: "From the screen to the printer.",
    body: "Change the body",
    bodyTag: "Mods",
    color: "Color every part",
    colorTag: "Palettes",
    pieces: "Bring your own pieces",
    piecesTag: "Socket cuts",
    export: "Export for print",
    plateAlt:
      "The 23 black armor pieces of Debug-Man 1.0 laid out in three rows, each with its joint sockets cut.",
    plateCount: "23 armor pieces",
    plateNote: "Sockets cut by DummyForge",
  },
  about: {
    label: "About",
    text: "vaan.dev is Ivan Mayoral, a software engineer in Mexico City. He designs, builds and runs every vaan.dev product. No client work.",
    resume: "Résumé",
    index: "Products",
    indexNow: "Public beta · 2026",
    indexNext: "Next product",
    indexNextTag: "On the bench",
  },
  footer: {
    social: "Elsewhere",
    linkedin: "LinkedIn",
    x: "X",
    theme: "Light theme",
    colophon: "© 2026 vaan.dev · Mexico City",
  },
  resume: {
    eyebrow: "Résumé",
    print: "Print / Save as PDF",
    contact: "Contact",
    experience: "Experience",
    skills: "Skills",
    education: "Education",
  },
};

export default en;
